import { render } from "./UiPageHero.vue?vue&type=template&id=7b44e760&ts=true"
import script from "./UiPageHero.vue?vue&type=script&lang=ts"
export * from "./UiPageHero.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__